<div class="notifications-component">
  <ul>
    @for (n of notifications; track n._id; let index = $index) {
      <li [ngClass]="notType(n)">
        @if (n.type === 'info') {
          <div class="notification-text-container">
            <span>
              @for (m of n.messages; track m) {
                <span>
                  {{ m | translate:n.values }}
                </span>
              }
            </span>
          </div>
        }
        @else {
          <div class="notification-text-container">
            <span>
              {{ 'TRANS__NOTIFICATION__DESCRIPTION' | translate }}
            </span>

            <span>
              <a href="https://support.kulturit.org/support/home" target="_blank" class="notification-text-container__url">
                {{ 'TRANS__NOTIFICATION__URL_DISPLAY' | translate }}
              </a>
            </span>


            @if (n.messages.length) {
              <span>
                {{ 'TRANS__NOTIFICATION__INFO_FOR_SUPPORT' | translate }}
              </span>

              <span>
                @for (m of n.messages; track m) {
                  <span>
                    {{ m | translate:n.values }}
                  </span>
                }
              </span>
            }
          </div>
        }

        <!--<button (click)="openSendEmailDialog(n)">
          {{'TRANS__NOTIFICATION_EMAIL__POPUP_LABEL' | translate}}
        </button>-->


        <button (click)="remove(index)">
          <mat-icon>
            close
          </mat-icon>
        </button>
      </li>
    }
  </ul>
</div>
